import React, { useState, useEffect } from "react"; 
import { motion } from "framer-motion"; 
import "./FunFact3.css"; 
import DYK from "./Assets/dyk.png"; 
import Clock from "./Assets/student.gif"; 

// FunFact3 component receives the onNext function as a prop, which is triggered when the user clicks "Next"
const FunFact3 = ({ onNext }) => {
  // State to manage the countdown timer (starts at 5 seconds)
  const [timer, setTimer] = useState(5);
  // State to manage visibility of the timer once it hits 0
  const [hideTimer, setHideTimer] = useState(false);

  // useEffect hook to handle the timer countdown
  useEffect(() => {
    if (timer > 0) {
      // Create an interval to decrement the timer by 1 every second
      const countdown = setInterval(
        () => setTimer((prevTime) => prevTime - 1),
        1000
      );
      return () => clearInterval(countdown); // Cleanup the interval when component unmounts or timer changes
    } else {
      // Once timer reaches 0, set a timeout to hide the timer after 1 second
      const hideTimeout = setTimeout(() => setHideTimer(true), 1000);
      return () => clearTimeout(hideTimeout); // Cleanup the timeout if the component unmounts
    }
  }, [timer]); // Hook depends on the 'timer' state, so it triggers when 'timer' changes

  return (
    <div className="funfact3-container">
      {/* Main container for FunFact3 component */}
      {/* Avatar image (animated clock gif) with framer-motion animation */}
      <motion.div
        className="avatar3-div" // Wrapper for the clock gif
        initial={{ opacity: 0, y: "50%" }} // Initial state: hidden and moved down
        animate={{ opacity: 1, y: 0 }} // Animate to full opacity and reset vertical position
        transition={{ duration: 1, ease: "easeOut" }} // Transition settings
      >
        <img className="avatar3-img1" src={Clock} alt="DYK" />{" "}
        {/* Clock image displayed */}
      </motion.div>
      {/* Content container for displaying the fact */}
      <motion.div
        className="cont3"
        initial={{ opacity: 0, y: "-50%" }} // Initial state: hidden and moved up
        animate={{ opacity: 1, y: 0 }} // Animate to full opacity and reset vertical position
        transition={{ duration: 1, ease: "easeOut" }} // Transition properties
      >
        <img className="dyk-img" src={DYK} alt="DYK" />{" "}
        {/* "Did You Know" image */}
        {/* Circular timer with dynamic styles */}
        <div
          className={`timer3-container ${hideTimer ? "hidden" : ""}`} // Hide the timer when it reaches 0
          style={{
            "--timer-percentage": (timer / 5) * 100, // Dynamically calculate the percentage for the circular timer
          }}
        >
          {/* Motion animated timer with scaling effect */}
          <motion.div
            className="circular-timer3"
            initial={{ opacity: 0, scale: 0.9 }} // Start with reduced opacity and scale
            animate={{ opacity: 1, scale: 1 }} // Animate to full opacity and scale
            exit={{ opacity: 0, scale: 0.9 }} // Exit effect: fade out and shrink
            transition={{ duration: 0.8 }} // Transition properties for the circular timer animation
          >
            {timer} {/* Display the timer value */}
          </motion.div>
        </div>
        {/* Fun fact paragraph */}
        <motion.p
          className="fun-p3"
          initial={{ opacity: 0, y: "10%" }} // Initial state: slightly visible and moved down
          animate={{ opacity: 1, y: 0 }} // Animate to full visibility and reset position
          exit={{ opacity: 0, y: "-10%" }} // Exit effect: fade out and move up
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }} // Transition duration, easing, and delay
        >
          {/* Fun fact content */}
          Interesting fact: Most PhD students spend between 4 to 5 years on
          their dissertation. If you could finish in 6 months with the help of
          AI and a structured workshop, how would that impact your career and
          your life? Now, imagine it’s possible, and it’s just one click away.
        </motion.p>
      </motion.div>
      {/* "Next" button with animation */}
      <motion.div
        className="btn-div3"
        initial={{ opacity: 0, y: "50%" }} // Initially hidden and moved down
        animate={{ opacity: 1, y: 0 }} // Animate to full opacity and reset position
        transition={{ duration: 1, ease: "easeOut", delay: 0.4 }} // Transition properties with delay
      >
        {/* "Next" button that becomes visible when the timer reaches 0 */}
        <button
          className={`next-button ${hideTimer ? "visible" : ""}`} // Button visibility controlled by hideTimer state
          onClick={onNext} // Trigger the onNext function when the button is clicked
          disabled={timer > 0} // Disable button if the timer is still running
        >
          Next
        </button>
      </motion.div>
    </div>
  );
};

export default FunFact3;
